import { Card } from "primereact/card";
import { Button } from "primereact/button";
import { type Suggestion, resolvePrompt } from "./chatSuggestionsData";

export interface ChatSuggestionsProps {
  suggestions: Suggestion[];
  tenant: string;
  sendMessage: (text: string) => void;
  setInput: (value: string) => void;
  setPendingSelection: (value: [number, number] | null) => void;
  disabled?: boolean;
}

export function ChatSuggestions({
  suggestions,
  tenant,
  sendMessage,
  setInput,
  setPendingSelection,
  disabled = false,
}: ChatSuggestionsProps) {
  return (
    <div
      className="grid grid-cols-1 sm:grid-cols-2 gap-3"
      role="list"
      aria-label="Suggested prompts"
    >
      {suggestions.map(s => {
        const handleActivate = () => {
          const { text, selection } = resolvePrompt(s.prompt, { tenant });
          if (s.autoSubmit === false) {
            setInput(text);
            setPendingSelection(selection ?? null);
          } else {
            sendMessage(text);
          }
        };
        return (
          <Card key={s.label} className="hover:shadow-lg transition-shadow" role="listitem">
            <Button
              className="w-full text-left bg-transparent border-0 p-0"
              onClick={handleActivate}
              disabled={disabled}
              aria-label={s.label}
            >
              <div className="flex items-start gap-3">
                <i className={`${s.icon} text-primary text-lg mt-0.5`} aria-hidden="true" />
                <div>
                  <div className="text-color font-semibold text-sm mb-1">{s.label}</div>
                  <div className="text-surface-500 text-xs leading-relaxed">
                    {resolvePrompt(s.prompt, { tenant }).text}
                  </div>
                </div>
              </div>
            </Button>
          </Card>
        );
      })}
    </div>
  );
}
